import {
  ACCOUNT_MARKETPLACE_GET_PAYMENT_METHODS,
  ACCOUNT_MARKETPLACE_ORDER_PROCESS,
  CALCULATE,
  CALCULATE_ACCOUNT_MARKETPLACE_ORDER,
  CALCULATE_ACCOUNTS,
  CALCULATE_FEE,
  DEPOSIT_CREATION_FEE,
  GET_ACCOUNT_DATA,
  GET_NETWORK_ACCOUNT_DATA,
  GET_PAYMENT_METHODS,
  RESET_DATA,
  SET_PAYMENT_METHOD_ACTIVE,
  TOP_UP,
  PUSH_PAYMENT_METHODS,
} from 'modules/Forms/Billing/types'

export const actionPushMethods = (props) => ({
  type: PUSH_PAYMENT_METHODS,
  payload: props,
})

export const actionGetNetworkAccountData = (props) => ({
  type: GET_NETWORK_ACCOUNT_DATA,
  payload: props,
})

export const actionGetAccountData = (props) => ({
  type: GET_ACCOUNT_DATA,
  payload: props,
})

export const actionGetPaymentMethods = (props) => ({
  type: GET_PAYMENT_METHODS,
  payload: props,
})

export const actionTopUp = (props) => ({
  type: TOP_UP,
  payload: props,
})

export const actionResetData = () => ({ type: RESET_DATA })

export const actionCalculate = (props) => ({
  type: CALCULATE,
  payload: props,
})

export const actionCalculateAccounts = (props) => ({
  type: CALCULATE_ACCOUNTS,
  payload: props,
})

export const actionSetActiveMethod = (props) => ({
  type: SET_PAYMENT_METHOD_ACTIVE,
  payload: props,
})

export const actionCalculateAccountMarket = (props) => ({
  type: CALCULATE_ACCOUNT_MARKETPLACE_ORDER,
  payload: props,
})

export const actionGetCalculateAccountMarketMethods = (props) => ({
  type: ACCOUNT_MARKETPLACE_GET_PAYMENT_METHODS,
  payload: props,
})

export const actionOrderAccountMarket = (props) => ({
  type: ACCOUNT_MARKETPLACE_ORDER_PROCESS,
  payload: props,
})

export const actionCalculateFee = (props) => ({
  type: CALCULATE_FEE,
  payload: props,
})

export const actionDepositCreationFee = (props) => ({
  type: DEPOSIT_CREATION_FEE,
  payload: props,
})
